import React from 'react'
import { Card, Form } from 'antd'
import UploadDocument from '../../uploadDocument/uploadDocument'

const mandatoryDocumentForms = [
  {
    name: 'fssaiDoc',
    label: 'FSSAI License/Registration',
    key: 'fssai',
    accept: 'application/pdf',
    maxCount: 1,
    description: 'PDF format, Max 2MB, 1 File'
  },
  {
    name: 'panDoc',
    label: 'PAN Card',
    key: 'pan',
    accept: 'application/pdf',
    maxCount: 1,
    description: 'PDF format, Max 2MB, 1 File'
  },
  {
    name: 'gstDoc',
    label: 'GST Certificate',
    key: 'gst',
    accept: 'application/pdf',
    maxCount: 1,
    description: 'PDF format, Max 2MB, 1 File'
  },
  {
    name: 'bankDetailsDoc',
    label: 'Bank Account Details (Canceled Cheque)',
    key: 'bankDetails',
    accept: 'application/pdf',
    maxCount: 1,
    description: 'PDF format, Max 2MB, 1 File'
  },
  {
    name: 'tradeLicenseDoc',
    label: 'Shop & Establishment/Trade License',
    key: 'tradeLicense',
    accept: 'application/pdf',
    maxCount: 1,
    description: 'PDF format, Max 2MB, 1 File'
  }
]

const menuDocumentForm = {
  name: 'menuDoc',
  label: 'Menu Card',
  key: 'menu',
  accept: 'image/jpeg',
  maxCount: 10,
  description: 'JPEG format, Max 2MB, Max 10 Files'
}

const DocumentsComponent = ({ vendorDetails, updateVendorInfo }: any) => {
  const handleDocumentChange = (docs: any, key: string) => {
    const updatedVendorDetails = { ...vendorDetails }
    if (!updatedVendorDetails.documents) {
      updatedVendorDetails.documents = {}
    }
    updatedVendorDetails.documents[key] = docs
    updateVendorInfo(updatedVendorDetails)
  }

  return (
    <Card title={<h2>Restaurant Documents</h2>} style={{ padding: '20px' }}>
      <div
        className='profile_flex'
        style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}
      >
        <Form layout='vertical'>
          <h3>Mandatory Documents</h3>
          <div
            className="profile-form-grid"
            style={{
              paddingBottom: '20px',
              borderBottom: '1px solid #f0f0f0',
              marginBottom: '30px'
            }}
          >
            {mandatoryDocumentForms.map((docForm) => (
              <Form.Item
                key={docForm.key}
                label={docForm.label}
                style={{ width: '100%', maxWidth: '400px' }}
              >
                <UploadDocument
                  value={vendorDetails?.documents?.[docForm.key] || []}
                  onChange={(newDocs: any) =>
                    handleDocumentChange(newDocs, docForm.key)
                  }
                  accept={docForm.accept}
                  maxCount={docForm.maxCount}
                  description={docForm.description}
                  name={docForm.name}
                  allowDelete={false}
                />
              </Form.Item>
            ))}
          </div>

          <h3>Menu</h3>
          <div className="profile-form-grid">
            <Form.Item
              key={menuDocumentForm.key}
              label={menuDocumentForm.label}
              style={{ width: '100%' }}
            >
              <UploadDocument
                value={vendorDetails?.documents?.[menuDocumentForm.key] || []}
                onChange={(newDocs: any) =>
                  handleDocumentChange(newDocs, menuDocumentForm.key)
                }
                accept={menuDocumentForm.accept}
                maxCount={menuDocumentForm.maxCount}
                description={menuDocumentForm.description}
                name={menuDocumentForm.name}
                allowDelete={false}
              />
            </Form.Item>
          </div>
        </Form>
      </div>
    </Card>
  )
}

export default DocumentsComponent
